// Tema "estudio": estudio de grabación (Fase 9.2). Arte propio.
const estudio = {
  id: 'estudio',
  rooms: {
    control: { label: 'Sala de control', hint: 'La orquestadora dirige la sesión desde la consola' },
    booths: { label: 'Cabinas', hint: 'Un agente de IA por cabina' },
    humans: { label: 'Sala de asesores', hint: 'Un puesto por asesor' },
    lobby: { label: 'Lobby', hint: 'Casos esperando asesor' },
  },
  words: {
    onAir: 'ON AIR',
    clip: 'CLIP',
    patchbay: 'Patchbay',
    patchbayHint: 'Conexiones del estudio',
    station: 'cabina',
  },
  station: 'cabin',        // cabina de grabación con vidrio y micrófono
  control: 'console',      // consola de mezcla
  decor: 'acoustic',       // paneles acústicos en las paredes
  colors: {
    bg: '#0b0a12',
    floor: '#1b1824',
    floorLine: 'rgba(255,255,255,0.035)',
    wallBack: '#2a2436',
    wallSide: '#211c2b',
    wallRim: '#3d3552',
    panel: '#352d46',
    panelAlt: '#2f2840',
    furniture: '#3b3349',
    furnitureTop: '#51476a',
    furnitureSide: '#2c2638',
    screen: '#0f172a',
    screenGlow: '#7c3aed',
    glass: 'rgba(167,139,250,0.10)',
    glassEdge: 'rgba(196,181,253,0.35)',
    accent: '#a78bfa',
    ai: '#8b5cf6',
    aiSkin: '#c4b5fd',
    lead: '#94a3b8',
    human: { online: '#22c55e', paused: '#f59e0b', offline: '#475569' },
    skin: '#e7c9a9',
    onAir: '#ef4444',
    onAirOff: '#3f1d24',
    clip: '#f43f5e',
    case: '#fbbf24',
    text: '#e2e8f0',
    muted: '#94a3b8',
    halo: '#0b0a12',
    cardBg: 'rgba(17,15,27,0.92)',
    cardBorder: 'rgba(167,139,250,0.35)',
    rack: '#16141f',
    rackEdge: '#2b2738',
    cable: { up: '#22c55e', down: '#ef4444', not_configured: '#475569', unknown: '#64748b' },
    vu: ['#22c55e', '#22c55e', '#22c55e', '#84cc16', '#eab308', '#f97316', '#ef4444'],
  },
};

export default estudio;
